import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import AdminVisits from "./AdminVisits";
import SupervisorVisits from "./SupervisorVisits";
import ParentVisits from "./ParentVisits";
import { Text } from "../../design/text";

/**
 * Role-based visits page that renders different content based on user role
 */
const RoleBasedVisits: React.FC = () => {
  const { role, isAdmin, isMonitor, isParent, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Text>Loading...</Text>
      </div>
    );
  }

  if (isAdmin) {
    return <AdminVisits />;
  }

  if (isMonitor) {
    return <SupervisorVisits />;
  }

  if (isParent) {
    return <ParentVisits />;
  }

  // Fallback
  return (
    <div className="flex items-center justify-center h-64">
      <Text className="text-zinc-500">Unknown role: {role}</Text>
    </div>
  );
};

export default RoleBasedVisits;
